import replace from 'lodash/replace';

const format = currency => {
  return replace(currency, /(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};

export default { format };
